const sortByDate = (data: any[]) => {
    return data.sort((a: any, b: any) => {
        const dateA = new Date(a.Date || a.attributes?.Date || '1970-01-01');
        const dateB = new Date(b.Date || b.attributes?.Date || '1970-01-01');
        return dateB.getTime() - dateA.getTime(); // Descending order (newest first)
    });
};

export default sortByDate;